import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authAxios, QueryStatus } from "../../../../utils";
import { RootState } from "../../../../redux/store";
import type { ContractDataVehicle } from "./vehicleContractDataApi";

export type VehicleContractDataState = {
  importContractDataStatus: QueryStatus;
};

const initialState: VehicleContractDataState = {
  importContractDataStatus: "idle",
};

export const uploadVehicleContractDataAsync = createAsyncThunk(
  "vehicleContractData/upload",
  async (
    payload: { vehicles: ContractDataVehicle[]; companyUuid: string },
    thunkAPI,
  ) => {
    const company = (thunkAPI.getState() as RootState).home.company;
    const axiosInstance = authAxios({ companyUuid: company?.uuid });
    await axiosInstance.post("vehicles/contract_data", {
      companyUuid: payload.companyUuid,
      vehicles: payload.vehicles,
    });
  },
);

export const vehicleContractDataSlice = createSlice({
  name: "vehicleContractData",
  initialState,
  reducers: {
    resetImportContractDataStatus(state) {
      state.importContractDataStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadVehicleContractDataAsync.pending, (state) => {
        state.importContractDataStatus = "processing";
      })
      .addCase(uploadVehicleContractDataAsync.fulfilled, (state) => {
        state.importContractDataStatus = "success";
      })
      .addCase(uploadVehicleContractDataAsync.rejected, (state) => {
        state.importContractDataStatus = "failed";
      });
  },
});

export const selectImportContractDataStatus = (state: RootState) =>
  state.vehicleContractData.importContractDataStatus;

export default vehicleContractDataSlice.reducer;
